<template>
  <span class="badge" :class="labelSpec">{{ text }}</span>
</template>

<script>
export default {
  props: ['title', 'type'],
  computed: {
    text() {
      return this.title.toUpperCase();
    },
    labelSpec() {
      if (this.type === 'Vendée Arctique') {
        return 'vendee_arctique';
      }
       else if (this.type === 'Route de Rhum') {
        return 'route_de_rhum';

      } else if (this.type === 'Transat Jacques Vabre') {
        return 'transat_jacques_vabre';
      } else if ((this.type === 'Rolex Fastnet Race')||(this.type === 'Fastnet Race')) {
        return 'rolex_fastnet_race';
      } else if (this.type === 'Bermudes 1000 Race') {
        return 'bermudes_1000_race';     
      }
        return null;
      }
  }
};
</script>

<style scoped>
.badge {
  background-color: rgb(56, 39, 39);
  color: #252525;
  border-radius: 30px;
  padding: 0.5rem 1.5rem;
  display: inline-block;
  margin-right: 0.5rem;
  background-color: #8d006e;
  color: white;
  margin-bottom: 0.5rem;
}

.vendee_arctique {
  background-color: #3d008d;
  color: white;
}

.transat_jacques_vabre {
  background-color: #71008d;
  color: white;
}

.rolex_fastnet_race {
 background-color :#0B610B;
  color: white;
}

.route_de_rhum {
  background-color:#0f2688;
   color: white;

}

.bermudes_1000_race {
  background-color:#B43104;
   color: white;

}
</style>
